'use client'
import {SanityImage} from '@local/ui/components'
import GlobeSVG from '@local/assets/svgs/icon-globe.svg'
import CalendarSVG from '@local/assets/svgs/icon-date.svg'
import {SanityImageType} from '@local/types'
import Link from 'next/link'

export interface GroupTripCardProps {
	image: SanityImageType
	date: string
	location: string
	title: string
	description: string
	link: {
		href: string
	}
}

export const GroupTripCard = ({title, image, description, link, date, location}: GroupTripCardProps) => {
	return (
		<Link href={link?.href || '#'}>
			<article className='group/btn'>
				<SanityImage
					image={image}
					width={572}
					height={372}
					desktopWidth={572}
					desktopOnly
					className='w-full flex-1 aspect-[572/372]' />
				<SanityImage
					image={image}
					width={355}
					height={230}
					mobileWidth={355}
					mobileOnly
					className='w-full' />

				<div className='flex py-16 flex-col gap-12 lg:w-3/5'>
					<div className='flex flex-row gap-12 items-center'>
						<div className='flex flex-row gap-8 items-center'>
							<GlobeSVG className='w-16 h-16 text-grey-2' />
							<span className='text-9 font-sans tracking-doubleWide font-medium leading-tight uppercase text-grey-2'>{location}</span>
						</div>
						<div className='flex flex-row gap-8 items-center'>
							<CalendarSVG className='w-16 h-16 text-grey-2' />
							<span className='text-9 font-sans tracking-doubleWide font-medium leading-tight uppercase text-grey-2'>{date}</span>
						</div>
					</div>

					<h3 className='text-18 font-serif font-medium leading-tight tracking-tight text-black lg:text-22'>{title}</h3>
					<p className='font-[350] text-12 lg:text-12 text-grey-4 leading-normal tracking-snug'>{description}</p>
				</div>
			</article>
		</Link>
	)
}
